import * as React from 'react'
import { BillToMatchListProps } from './typings'
import { BillToMatchCard } from './BillToMatchCard'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

export const BillToMatchList: React.FC<BillToMatchListProps> = (props) => {
  const { styles, loading, billTos } = props

  return (
    <Box mt={2} flexGrow={1} display="flex" flexDirection="column">
      {loading ? (
        <CircularProgress color="primary" sx={styles.loadingSpinner} />
      ) : (
        billTos.map((loc) => (
          <BillToMatchCard {...props} key={loc.id} billTo={loc} />
        ))
      )}
    </Box>
  )
}
BillToMatchList.displayName = 'BillToMatchList'
